(function (root, factory) {
  if (typeof module === 'object' && module.exports) {

    module.exports = factory();

  } else {

    root['watermark'] = factory();
  }
}(this, function () {

  const watermark = {};

  let forceRemove = false;

  const defaultSettings = {
    watermarkId: 'watermark',           // 水印总体的id
    markItemPrefix: 'maskItem',         // 水印元素的id前缀
    text: '',                           // 水印内容
    startX: -1000,                       // 水印起始位置x轴坐标
    startY: -1200,                       // 水印起始位置Y轴坐标
    rows: 30,                           // 水印行数
    cols: 20,                            // 水印列数
    fontFamily: '微软雅黑',              // 水印字体
    color: '#bbb',                      // 水印字体颜色
    fontSize: '16px',                   // 水印字体大小
    alpha: 0.30,                        // 水印透明度，要求设置在大于等于0.005
    angle: 20,                          // 水印倾斜度数
    monitor: true,                      // monitor 是否监控， true: 不可删除水印; false: 可删水印。
  };

  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

  //监听dom是否被移除或者改变属性的回调函数
  const changeCallback = function (records) {

    if (forceRemove) {

      forceRemove = false;
      return;
    }

    if ((globalSetting && records.length === 1) || records.length === 1 && records[0].removedNodes.length >= 1) {

      loadMark(globalSetting);
    }
  };

  const _hasObserver = MutationObserver !== undefined;

  const watermarkObserver = _hasObserver ? new MutationObserver(changeCallback) : null;

  const option = {
    'childList': true,
    'attributes': true,
    'subtree': true,
    'attributeFilter': ['style'],
    'attributeOldValue': true
  };

  // 加载水印方法
  const loadMark = function (settings) {

    // 设置配置参数
    if (arguments.length === 1 && typeof arguments[0] === "object") {
      const args = arguments[0] || {};

      for (let key in args) {
        if (args[key] && defaultSettings[key] && args[key] === defaultSettings[key]) {
          continue;
        }
        else if (args[key] || args[key] === 0) {
          defaultSettings[key] = args[key]
        };
      }
    }

    let _body = document.body;

    let _shadowRoot = null;

    let _watermark = document.getElementById(defaultSettings.watermarkId);
    // 重新加载水印时,需要清理以前的内容
    _watermark && _watermark.parentNode && _watermark.parentNode.removeChild(_watermark);

    // 创建水印容器
    _watermark = document.createElement('div');
    _watermark.id = defaultSettings.watermarkId;
    _watermark.setAttribute('style', 'pointer-events: none !important; display: block !important; overflow: hidden');

    // 判断浏览器是否支持attachShadow方法
    if (typeof _watermark.attachShadow === 'function') {

      // 挂载 shadow dom
      _shadowRoot = _watermark.attachShadow({ mode: 'open' });

    } else {

      _shadowRoot = _watermark.shadowRoot;

    }

    // 将shadow dom随机插入body内的任意位置
    const childNodes = _body.children;
    const idx = Math.floor(Math.random() * (childNodes.length - 1));

    if (childNodes[idx]) {

      _body.insertBefore(_watermark, childNodes[idx]);

    } else {

      _body.appendChild(_watermark);

    }

    let _startY;

    for (let i = 0; i < defaultSettings.rows; i++) {

      _startY = defaultSettings.startY + 160 * i;

      // 行容器
      const rowContainer = document.createElement('div');
      // 设置水印div倾斜显示
      rowContainer.style.transform = "rotate(-" + defaultSettings.angle + "deg)";
      // 绝对定位
      rowContainer.style.position = "absolute";

      rowContainer.style.transformOrigin = "10% 40%";
      // 缩进
      const x = defaultSettings.startX + 80 * i;

      rowContainer.style.left = x + 'px';
      rowContainer.style.top = _startY + 'px';
      rowContainer.style.overflow = "hidden";
      rowContainer.style.whiteSpace = "nowrap";
      rowContainer.style.zIndex = "1204";
      rowContainer.style.opacity = defaultSettings.alpha;

      for (let j = 0; j < defaultSettings.cols; j++) {

        const watermarkItem = defaultSettings.text.split(';').filter(v => v);

        for (let t = 0; t < watermarkItem.length; t++) {

          const maskItem = document.createElement('div');
          const textNode = document.createTextNode(watermarkItem[t]);
          maskItem.appendChild(textNode);

          maskItem.style.fontSize = defaultSettings.fontSize;
          maskItem.style.fontFamily = defaultSettings.fontFamily;
          maskItem.style.color = defaultSettings.color;

          maskItem.style.margin = "0 70px";
          //maskItem.style.border = "1px solid orange";
          maskItem.style.display = "inline-block";
          // 不允许选中
          maskItem.style['-ms-user-select'] = "none";

          rowContainer.appendChild(maskItem);
        }
      }

      _shadowRoot.appendChild(rowContainer);
    }

    // monitor 是否监控， true: 不可删除水印; false: 可删水印。
    const _monitor = settings.monitor === undefined ? defaultSettings.monitor : settings.monitor;
    if (_monitor && _hasObserver) {

      watermarkObserver.observe(_body, option);
      watermarkObserver.observe(_watermark.shadowRoot, option);
    }
  };

  // 移除水印
  const removeMark = function () {

    if (arguments.length === 1 && typeof arguments[0] === "object") {

      const args = arguments[0] || {};
      for (let key in args) {

        if (args[key] && defaultSettings[key] && args[key] === defaultSettings[key]){

          continue;
        }
        else if (args[key] || args[key] === 0) {

          defaultSettings[key] = args[key];
        }
      }
    }

    // 移除水印
    const _watermark = document.getElementById(defaultSettings.watermarkId);
    const _parentNode = _watermark.parentNode;
    _parentNode.removeChild(_watermark);

    watermarkObserver.disconnect();
  };

  let globalSetting;
  // 初始化水印，添加load和resize事件
  watermark.init = function (settings) {
    globalSetting = settings;
    loadMark(settings);
    window.addEventListener('onload', function () {
      loadMark(settings);
    });
    window.addEventListener('resize', function () {
      loadMark(settings);
    });
  };

  // 加载水印
  watermark.load = function (settings) {
    globalSetting = settings;
    loadMark(settings);
  };

  // 移除水印
  watermark.remove = function () {
    forceRemove = true;
    removeMark();
  };

  return watermark;

}));